<template>
  <!-- Footer -->
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <span class="copyright">Copyright &copy; blackmondayradio.nl {{currentYear}}</span>
        </div>
        <div class="col-md-4">
          <ul class="list-inline social-buttons">
            <li class="list-inline-item">
              <a title="Twitch" href="https://www.twitch.tv/blackmondayradio" target="_blank">
                <i class="fab fa-twitch"></i>
              </a>
            </li>

            <li class="list-inline-item">
              <a title="Instagram" href="https://www.instagram.com/blackmondayradio" target="_blank">
                <i class="fab fa-instagram"></i>
              </a>
            </li>

            <li class="list-inline-item">
              <a title="FaceBook" href="https://www.facebook.com/blackmondayradioshow" target="_blank">
                <i class="fab fa-facebook-f"></i>
              </a>
            </li>

            <li class="list-inline-item">
              <a title="Twitter" href="https://twitter.com/blackmondaydfm" target="_blank">
                <i class="fab fa-twitter"></i>
              </a>
            </li>

            <li class="list-inline-item">
              <a title="MixCloud" href="https://www.mixcloud.com/BlackMondayRadioshow" target="_blank">
                <i class="fab fa-mixcloud"></i>
              </a>
            </li>

            <li class="list-inline-item">
              <a title="TuneIn" href="http://tun.in/pjGgd" target="_blank">
                <i class="fas fa-broadcast-tower"></i>
              </a>
            </li>            
          </ul>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    name: "appFooter",
    data: function(){
        return {
            currentYear: new Date().getFullYear()
        };
    }
}
</script>
<style scoped>

footer {
 padding:25px 0;
 text-align:center
}
footer span.copyright,
footer ul.quicklinks {
 font-size:90%;
 line-height:40px;
 text-transform:none;
 font-family:Montserrat,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif
}
footer ul.quicklinks {
 margin-bottom:0
}
ul.social-buttons li a {
 font-size:20px;
 line-height:50px;
 display:block;
 width:50px;
 height:50px;
 -webkit-transition:all .3s;
 transition:all .3s;
 color:#fff;
 border-radius:100%;
 outline:none;
 background-color:#212529
}
ul.social-buttons li a:active,
ul.social-buttons li a:focus,
ul.social-buttons li a:hover {
 background-color:#e35313
}
</style>